<template>
  <div class="input input-default">
    <a v-if="help" href="#" class="input--help">Help</a>
    <label class="input--label">{{ label }}:</label>
    <input class="input--control" :type="type" :value="value" v-on:input="$emit('input', $event.target.value)" :autocapitalize="capitalizeNone"/>
    <em v-if="description" class="input--desc">{{ description }}</em>
  </div>
</template>

<script>
  export default {
    props:{
      label: String, 
      value: String, 
      description: String, 
      help: String, 
      capitalizeNone: String, 
      type: {default: 'text', type: String}
    }
  }
</script>